export const PoemCapitalizeOnThis = () => {
    return (
        <div id="017" className="">
            <p>mixed emotions, dry skin,</p>
            <p>trying to find the keyhole to this door for months now,</p>
            <p>so much so that this already feels like the new norm,</p>
            <p>the in-between place before the actual place,</p>
            <p>The "Hundred Years, Maybe" Waiting Room,</p>
            <p>stamps on a passport,</p>
            <p>high hopes, out there in limbo,</p>
            <p>while i'm waiting to be vetted by God himself,</p>
            <p>time continues crawling like a swarm of ants,</p>
            <p>i take my place</p>
            <p>somewhere in my age demographic,</p>
            <p>in my weight group,</p>
            <p>somewhere in the men's section, blending in with the others,</p>
            <p>everything prêt-à-porter, even the people,</p>
            <p>especially the people,</p>
            <p>
                do you ever feel like you might be replaced and not feel a thing
                when it happens?
            </p>
            <p>Neither Do I,</p>
            <p>slow burn greek tragedy,</p>
            <p>
                even if there are no bullets, let me see what it feels like to
            </p>
            <p>hold the gun to my head -</p>
            <p>the anticipation of</p>
            <p>Something Finally Happening,</p>
            <p>even if it could be the worst thing possible.</p>
            <p>or it might not,</p>
            <p>like when you spill coffee over the picture you were drawing</p>
            <p>and the stain actually makes it more interesting to look at.</p>
            <br />
            <p>sometimes when i sit in traffic</p>
            <p>the camera zooms out to take a shot of</p>
            <p>the street and the shops and the people walking,</p>
            <p>and every now and then it loses track of me through the </p>
            <p>50-60 other cars waiting at the red light</p>
            <p>so i have to</p>
            <p>wave my arms a bit so the movie doesn't skip to</p>
            <p>Something Else.</p>
        </div>
    );
};
